import type { FC } from 'react';

import {
    Body1,
    Box,
    Flex,
    Image,
    Subtitle1,
} from '@myphx-engineering/phx-design-system';

import { drugImageMaxHeight, drugImageMaxWidth } from '../../../constants';
import type { NdcSwitchTarget } from '../../../types/drug-config';

import classes from './switch-target-header.module.css';

export type SwitchTargetHeaderProps = {
    option: NdcSwitchTarget;
};

export const SwitchTargetHeader: FC<SwitchTargetHeaderProps> = ({ option }) => {
    const {
        heading,
        imageOrientation = 'portrait',
        imageUrl,
        quantity,
    } = option;

    const maxHeight =
        imageOrientation === 'landscape'
            ? drugImageMaxHeight
            : drugImageMaxWidth;
    const maxWidth =
        imageOrientation === 'landscape'
            ? drugImageMaxWidth
            : drugImageMaxHeight;

    return (
        <Box className={classes.container}>
            <Flex
                direction={imageOrientation === 'portrait' ? 'row' : 'column'}
                className={classes.wrapper}
                gap="xxs"
            >
                <Box className={classes.description}>
                    <Subtitle1>{heading}</Subtitle1>
                    <Body1>Quantity: {quantity || 1}</Body1>
                </Box>
                {imageUrl ? (
                    <Box>
                        <Image
                            src={imageUrl}
                            aria-hidden="true"
                            fit="contain"
                            maw={maxWidth}
                            mah={maxHeight}
                        />
                    </Box>
                ) : null}
            </Flex>
        </Box>
    );
};
